import api from './api';

export default {
	download(arquivo) {
		let url = '/download/file/?';

		if (arquivo.key) {
			url += `key=${arquivo.key}&id=`;
		} else if (arquivo.id) {
			url += `id=${arquivo.id}&key=`;
		}

		return api.get(url, { responseType: 'arraybuffer' });
	},

	downloadTemplate(tipoDocumento) {
		let url = '/download/modelo/';
		url += `${tipoDocumento}`;

		return api.get(url, { responseType: 'arraybuffer' });
	},
};
